import React from 'react'
import styled from 'styled-components'
import Arrow from './Arrow'
import { rem } from 'polished'

const Line = styled.div`
  width: 100%;
  height: ${rem(2)};
  background-color: currentColor;

  @media print {
    width: 100%;
    height: ${rem(2)};
    background-color: black !important;
  }
`

const Edge = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  -webkit-print-color-adjust:exact !important;
  print-color-adjust:exact !important;
`

const PositionedArrow = styled(Arrow)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%) translateX(33%);
  stroke: currentColor;
  stroke-width: 2px;
`

interface Props {
  arrowSize?: number
  className?: string
  width?: number | string
  minWidth?: number | string
  height?: number
}

function FullArrow(props: Props) {
  const { arrowSize, className, height, width, minWidth } = props
  const style = {
    height,
    width,
    minWidth,
  }
  return (
    <Edge className={className} style={style}>
      <Line />
      <PositionedArrow size={arrowSize} />
    </Edge>
  )
}

FullArrow.defaultProps = {
  arrowSize: 16,
}

export default FullArrow
